module.exports = __webpack_public_path__ + "no.b855834ec80ba4ec04cd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/no.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/no.svg
// module chunks = styles